import React, { useEffect, useState } from "react";

import { Text, StyleSheet, Platform } from "react-native";
import AppTheme from "../AppTheme";

export default function ManaTextMore(props) {
  const {
    text = "",
    size = 50,
    style = {},
    collapsed = true,
    onToggle,
  } = props;
  const [textToDisplay, setTextToDisplay] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  useEffect(() => {
    setIsCollapsed(collapsed);
    setTextToDisplay(getText(collapsed));
  }, [text, collapsed]);

  const getText = (hidden = true) => {
    const hasMore = hidden ? text.length > size : false;
    return (
      text.substr(0, !hidden ? text.length : size) + (hasMore ? "..." : "")
    );
  };

  const toggleShowMore = () => {
    if (onToggle) {
      onToggle();
      return;
    }
    setIsCollapsed(!isCollapsed);
    setTextToDisplay(getText(!isCollapsed));
  };

  return (
    <Text onPress={toggleShowMore} style={[styles.text, style]} {...props}>
      {textToDisplay}
    </Text>
  );
}

const styles = StyleSheet.create({
  text: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
});
